import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  ChangeReportAccessRequest,
  ChangeReportAccessResponse,
  ReportDetailsResponse,
  ReportHistoryRequest,
  ReportHistoryResponse
} from '@/app/Report/types/reportApiTypes';

const reportApi = createApi({
  reducerPath: 'report',
  baseQuery: (...args: unknown[]) =>
    customFetchBase(getBaseApiPath(), ...args),
  tagTypes: ['REPORT_HISTORY'],
  endpoints: build => ({
    getReportHistoryCount: build.query<
      ReportHistoryResponse,
      ReportHistoryRequest
    >({
      query: body => ({
        url: `/go_report/v1/tracker/get`,
        method: 'POST',
        body
      }),
      providesTags: ['REPORT_HISTORY']
    }),
    getReportHistory: build.mutation<
      ReportHistoryResponse,
      ReportHistoryRequest
    >({
      query: body => ({
        url: `/go_report/v1/tracker/get`,
        method: 'POST',
        body
      })
    }),
    getReportDetails: build.query<ReportDetailsResponse, string>({
      query: id => ({
        url: `/go_report/v1/tracker/view/get_by_id`,
        method: 'POST',
        body: { id }
      })
    }),
    changeReportAccess: build.mutation<
      ChangeReportAccessResponse,
      ChangeReportAccessRequest
    >({
      query: body => ({
        url: `/go_report/v1/tracker/change_access`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['REPORT_HISTORY']
    })
  })
});

export const {
  useGetReportHistoryCountQuery,
  useGetReportHistoryMutation,
  useGetReportDetailsQuery,
  useChangeReportAccessMutation
} = reportApi;

export default reportApi;
